import React, { useEffect, useState } from "react";
import { Button, Box } from "@mui/material";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BackButton = () => {
  const navigate = useNavigate();
  const [backRoute, setBackRoute] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const storedBackRoute = localStorage.getItem("back");
    if (storedBackRoute) {
      setBackRoute(storedBackRoute);
    }
  }, []);

  const handleGoBack = () => {
    if (backRoute) {
      localStorage.removeItem("back");
      navigate(backRoute);
    }
  };

  if (!backRoute) return null;

  return (
    <Box sx={{ top: 16, left: 16 }}>
      <Button
        color="primary"
        variant="contained"
        size="small"
        startIcon={<KeyboardArrowLeftIcon sx={{ color: "#fff", fontSize: 14 }} />}
        onClick={handleGoBack}
        sx={{
          color: "#fff",
          fontSize: '.8rem',
          gap: '0px',
          minWidth: 'auto',
          padding: '6px 10px',
        }}
      >
        {t('go_back')}
      </Button>
    </Box>
  );
};

export default BackButton;
